import { CONST } from '../utils/constants';
import { CostTypeEnum } from './reference';

export interface AttendeeFixedCost {
  attendeeId: string; //System.Guid
  costId: string; //System.Guid
  costName: string;
  costType: CostTypeEnum;
  costAmount: number;
  enabled: boolean;
}

function toAPI(data: Partial<AttendeeFixedCost>) {
  return {
    AttendeeId: data.attendeeId || CONST.emptyGuid,
    CostId: data.costId || CONST.emptyGuid,
    Enabled: data.enabled ?? true,
  };
}

function parse(data?: Partial<AttendeeFixedCost>): AttendeeFixedCost {
  return {
    attendeeId: data?.attendeeId || CONST.emptyGuid,
    costId: data?.costId || CONST.emptyGuid,
    costName: data?.costName ?? '',
    costType: data?.costType ?? CostTypeEnum.ForRegistration,
    costAmount: data?.costAmount ?? 0,
    enabled: data?.enabled ?? true,
  };
}

export default {
  parse,
  toAPI,
};
